import _ from 'lodash'
import root from './root'

const HISTORY_KEY = 'history'

root[HISTORY_KEY] = root[HISTORY_KEY] || []

const push = ({ event, type, params = {}, data = {}, path = '' }) => {
  root[HISTORY_KEY].push({ event, type, params, path, value: data })
}

const get = (path = '') => {
  return _.get(root, `${HISTORY_KEY}${path}`)
}

export default { get, push }
